export const palette = {
  primary: "#d2a473",
  secondary: "#1c3970",
  blue: "#2298ee",
  success: "#35c07d", // green
  warning: "#ffb347", // orange
  danger: "#e0293e", // red

  // Gray colors
  white: "#ffffff", // indihu white
  "light-gray": "#e9ecef",
  "medium-gray": "#ced4da",
  "muted-400": "#a6acb3", // additional color
  gray: "#6c757d", // indihu gray
  "dark-gray": "#343a40",
  black: "#121416", // indihu black

  // Default background color
  background: "#393d41",

  // Theme colors (from figma)
  "dark-mode-b": "#202326", // background color in dark mode
  "light-mode-b": "#ffffff", // background color in light mode (white)
  "dark-mode-f": "#ffffff", // text (foreground) color in dark mode (white text on dark background)
  "light-mode-f": "#121416", // text (foreground) color in light mode (black text on light background)

  // Administration primary blue
  "primary-blue": "#142E54",
};
